import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@paypalcorp/pp-react';
import getContent from '../lib/dictionaryFetcher';
import { QUIZ_CONSTANTS } from '../lib/constants';

const PopOverContent = props => {
  const {
    feedbackTextCount,
    feedbackTextVal,
    submitPopOver,
    feedbackNoTextError,
    textareaCount,
    labelledBy
  } = props;
  return (
    <React.Fragment>
      <textarea
        style={{ border: feedbackNoTextError && '1px solid red' }}
        value={feedbackTextVal}
        onChange={e => {
          textareaCount(e);
        }}
        className="feedback-quiz-textarea"
        placeholder={getContent('quiz', 'feedback.textareaPlaceholder')}
        aria-labelledby={labelledBy}
      ></textarea>
      {feedbackNoTextError && (
        <div style={{ marginBottom: '5px' }}>
          <div
            className="ppvx_text-input__error-text step-error-container-image"
            style={{ margin: '0px' }}
          >
            <span className="feedback-quiz-textarea-error">
              {getContent('quiz', 'feedback.textareaError')}
            </span>
          </div>
        </div>
      )}
      <Button
        onClick={() => {
          submitPopOver(feedbackTextVal);
        }}
        className="feedback-submit-button add-focus-visible"
        size="sm"
      >
        {getContent('quiz', 'feedback.submit')}
      </Button>
      <p className="feedback-quiz-count">
        {feedbackTextCount}/{QUIZ_CONSTANTS.feedback.maxCount}
      </p>
    </React.Fragment>
  );
};

PopOverContent.propTypes = {
  feedbackTextCount: PropTypes.number,
  feedbackTextVal: PropTypes.string,
  submitPopOver: PropTypes.func,
  textareaCount: PropTypes.func,
  feedbackNoTextError: PropTypes.bool,
  labelledBy: PropTypes.string.isRequired
};

export default PopOverContent;
